module.exports = __webpack_public_path__ + "img/sol.f2c164bd.png";